var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "page c-post__page", attrs: { role: "main" } },
    [
      _c("div", { staticClass: "post" }, [
        _c("div", { staticClass: "o-wrapper" }, [
          _vm.post
            ? _c(
                "article",
                { staticClass: "post__view post__click o-grid o-grid--center" },
                [
                  _c(
                    "header",
                    {
                      staticClass:
                        "o-grid__item u-width-full u-m-t6 u-m-t4@l u-m-t2@m",
                    },
                    [
                      _c(
                        "div",
                        {
                          ref: "articleHead",
                          staticClass:
                            "o-grid--center u-width-5/8 u-width-10/12@l u-width-full@m u-center",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "post__details" },
                            [
                              _c(
                                "div",
                                {
                                  ref: "articleTitle",
                                  class: [
                                    "post__wrap",
                                    _vm.sticky ? "scroll" : "",
                                  ],
                                },
                                [
                                  _vm.post && _vm.post.repost_id > 0
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            ref: "communityLogo",
                                            staticClass: "post__community-img",
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href:
                                                    "/" +
                                                    _vm.post.community_url,
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: _vm.$simpleStore.transformImageWithCloudfront(
                                                      64,
                                                      64,
                                                      "img/communities/" +
                                                        _vm.post.community_id +
                                                        "/" +
                                                        _vm.post
                                                          .community_thumbnail,
                                                      _vm.$root
                                                    ),
                                                    alt: _vm.post
                                                      .community_name,
                                                  },
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.post.source_community_id > 0
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "post__community-img-source",
                                                    attrs: {
                                                      href:
                                                        "/" +
                                                        _vm.post
                                                          .source_community_url,
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.$simpleStore.transformImageWithCloudfront(
                                                          25,
                                                          25,
                                                          "img/communities/" +
                                                            _vm.post
                                                              .source_community_id +
                                                            "/" +
                                                            _vm.post
                                                              .source_community_image,
                                                          _vm.$root
                                                        ),
                                                        alt: _vm.post
                                                          .source_community_name,
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "post__from" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "post__from-community",
                                              },
                                              [
                                                _c("p", [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href:
                                                          "/" +
                                                          _vm.post
                                                            .community_url,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.post
                                                            .community_name
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "post__from-details",
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v("Reposted from"),
                                                ]),
                                                _vm._v(" "),
                                                _vm.post.source_community_id > 0
                                                  ? _c("p", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href:
                                                              "/" +
                                                              _vm.post
                                                                .source_community_url,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.post
                                                                .source_community_name
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm.post &&
                                      _vm.post.network_id ===
                                        _vm.$simpleStore.Networks.DY
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "post__ugc" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "post__ugc-img" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "post__ugc-img--user",
                                                    attrs: {
                                                      href:
                                                        "/u/" +
                                                        _vm.post.username,
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.post
                                                          .user_avatar,
                                                        alt:
                                                          "Article Posted by " +
                                                          _vm.post.first_name +
                                                          " " +
                                                          _vm.post.surname,
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "post__ugc-img--community",
                                                    attrs: {
                                                      href:
                                                        "/" +
                                                        _vm.post.community_url,
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.$simpleStore.transformImageWithCloudfront(
                                                          25,
                                                          25,
                                                          "img/communities/" +
                                                            _vm.post
                                                              .community_id +
                                                            "/" +
                                                            _vm.post
                                                              .community_thumbnail,
                                                          _vm.$root
                                                        ),
                                                        alt: _vm.post
                                                          .community_name,
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "post__ugc-details",
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "post__ugc-user",
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href:
                                                            "/u/" +
                                                            _vm.post.username,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                        " +
                                                            _vm._s(
                                                              _vm.post
                                                                .first_name
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.post.surname
                                                            ) +
                                                            "\n                                                    "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "svg",
                                                      {
                                                        attrs: {
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg",
                                                          width: "24",
                                                          height: "23",
                                                          viewBox: "0 0 24 23",
                                                          fill: "none",
                                                        },
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M13.0678 1.87572L12.6127 2.46668L13.0678 1.87572C12.4384 1.39102 11.5616 1.39102 10.9322 1.87572L9.45555 3.01297L9.81993 3.48609L9.45555 3.01297C9.40604 3.0511 9.34404 3.06931 9.28177 3.064L7.42469 2.90562C6.63319 2.83812 5.89551 3.3122 5.62811 4.06021L5.00072 5.81526C4.97968 5.87411 4.93737 5.92295 4.88211 5.95214L3.23421 6.82292C2.53187 7.19405 2.1676 7.99169 2.34705 8.76553L2.76811 10.5812C2.78223 10.642 2.77303 10.706 2.74233 10.7604L1.82681 12.3839L2.47756 12.7509L1.82681 12.3839C1.43661 13.0758 1.5614 13.9438 2.13074 14.4978L3.46656 15.7975C3.51135 15.8411 3.53819 15.8999 3.5418 15.9623L3.64932 17.823C3.69515 18.6161 4.26939 19.2788 5.04784 19.437L6.87431 19.8082C6.93556 19.8207 6.98992 19.8556 7.02668 19.9061L8.12312 21.4133C8.59042 22.0557 9.43178 22.3028 10.1722 22.015L11.9094 21.3398L11.6378 20.6408L11.9094 21.3398C11.9677 21.3172 12.0323 21.3172 12.0906 21.3398L12.3622 20.6408L12.0906 21.3398L13.8278 22.015C14.5682 22.3028 15.4096 22.0557 15.8769 21.4133L16.9733 19.9061C17.0101 19.8556 17.0644 19.8207 17.1257 19.8082L18.9522 19.437C19.7306 19.2788 20.3048 18.6161 20.3507 17.823L20.4582 15.9623C20.4618 15.8999 20.4887 15.8411 20.5334 15.7975L21.8693 14.4978C22.4386 13.9438 22.5634 13.0758 22.1732 12.3839L21.2577 10.7604C21.227 10.706 21.2178 10.642 21.2319 10.5812L21.6529 8.76553C21.8324 7.99169 21.4681 7.19405 20.7658 6.82292L19.1179 5.95214C19.0626 5.92295 19.0203 5.87411 18.9993 5.81526L18.3719 4.06021C18.1045 3.3122 17.3668 2.83812 16.5753 2.90562L14.7182 3.064C14.656 3.06931 14.594 3.0511 14.5444 3.01297L13.0678 1.87572Z",
                                                            fill: "#DB2848",
                                                            stroke: "white",
                                                            "stroke-width":
                                                              "1.5",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M9 11.7419L11.1538 14L15 9",
                                                            stroke: "white",
                                                            "stroke-width":
                                                              "1.5",
                                                            "stroke-linecap":
                                                              "round",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "post__ugc-community",
                                                  },
                                                  [
                                                    _c("span", [_vm._v("in ")]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href:
                                                            "/" +
                                                            _vm.post
                                                              .community_url,
                                                          id: "article-community-name",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                        " +
                                                            _vm._s(
                                                              _vm.post
                                                                .community_name
                                                            ) +
                                                            "\n                                                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "post__ugc-date",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          _vm.post.birthday_long
                                                        ) +
                                                        "\n                                                "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : [
                                        _c(
                                          "div",
                                          {
                                            ref: "communityLogo",
                                            staticClass: "post__community-img",
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href:
                                                    "/" +
                                                    _vm.post.community_url,
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: _vm.$simpleStore.transformImageWithCloudfront(
                                                      64,
                                                      64,
                                                      "img/communities/" +
                                                        _vm.post.community_id +
                                                        "/" +
                                                        _vm.post
                                                          .community_thumbnail,
                                                      _vm.$root
                                                    ),
                                                    alt: _vm.post
                                                      .community_name,
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "post__from" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "post__from-community",
                                              },
                                              [
                                                _c("p", [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href:
                                                          "/" +
                                                          _vm.post
                                                            .community_url,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.post
                                                            .community_name
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "post__from-details",
                                              },
                                              [
                                                _c("p", [_vm._v("Posted on")]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.post.duplicates,
                                                  function (dupe, index) {
                                                    return [
                                                      _c(
                                                        "a",
                                                        {
                                                          class: [
                                                            "post__social",
                                                            (!_vm.$route.params
                                                              .post_id &&
                                                              index === 0) ||
                                                            _vm.$route.params
                                                              .post_id ===
                                                              dupe.post_id.toString()
                                                              ? "active"
                                                              : "",
                                                          ],
                                                          attrs: {
                                                            href:
                                                              "/" +
                                                              _vm.post
                                                                .community_url +
                                                              "/" +
                                                              _vm.post
                                                                .dyadey_id +
                                                              (index > 0
                                                                ? "/" +
                                                                  dupe.post_id
                                                                : ""),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              _vm.post
                                                                .duplicates
                                                                .length > 1
                                                                ? _vm.showNetworkPost(
                                                                    $event,
                                                                    index,
                                                                    dupe.network_id,
                                                                    _vm.post
                                                                      .dyadey_id,
                                                                    dupe.post_id
                                                                  )
                                                                : null
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src: _vm.getNetworkIcon(
                                                                dupe.network_id
                                                              ),
                                                              alt: "",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  }
                                                ),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _c(
                                                    "time",
                                                    {
                                                      attrs: {
                                                        datetime:
                                                          _vm.postBirthdayDatetime,
                                                        title:
                                                          _vm.postBirthdayDatetime,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                        " +
                                                          _vm._s(
                                                            _vm.postBirthdayWords
                                                          ) +
                                                          "\n                                                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                      ],
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class: ["post__menu"],
                                  on: { click: _vm.togglePostMenu },
                                },
                                [_vm._m(0)]
                              ),
                              _vm._v(" "),
                              _c(
                                "Menu",
                                {
                                  attrs: {
                                    "show-menu": _vm.showContextMenu,
                                    "close-event": "bus-index-post-menu-close",
                                  },
                                },
                                [
                                  _vm.post.network_id ===
                                  _vm.$simpleStore.Networks.DY
                                    ? _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "menu__links" },
                                          [
                                            _c("a", { attrs: { href: "#" } }, [
                                              _vm._v("Share"),
                                            ]),
                                            _vm._v(" "),
                                            !_vm.post.repost_id
                                              ? [
                                                  _c(
                                                    "a",
                                                    { attrs: { href: "#0" } },
                                                    [_vm._v("Flag Content")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    { attrs: { href: "#0" } },
                                                    [_vm._v("Hide User Posts")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    { attrs: { href: "#0" } },
                                                    [_vm._v("Report User")]
                                                  ),
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("CopyLink", {
                                              attrs: {
                                                link:
                                                  "/" +
                                                  _vm.post.community_url +
                                                  "/" +
                                                  _vm.post.dyadey_id,
                                                "menu-name-event":
                                                  "bus-post-menu-toggle",
                                              },
                                            }),
                                            _vm._v(" "),
                                            !_vm.post.repost_id
                                              ? _c(
                                                  "a",
                                                  { attrs: { href: "#" } },
                                                  [
                                                    _vm._v(
                                                      "Repost to a community"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.post.repost_id > 0 &&
                                            _vm.originalSourceUrl
                                              ? _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: _vm.originalSourceUrl,
                                                    },
                                                    on: {
                                                      click: _vm.togglePostMenu,
                                                    },
                                                  },
                                                  [_vm._v("View original post")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.$root.user !== false &&
                                            _vm.post.user_id ===
                                              _vm.$root.user.id
                                              ? _c(
                                                  "a",
                                                  {
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.modalDeletePost(
                                                          _vm.post.post_id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                Delete Post "
                                                    ),
                                                    _c("em", [
                                                      _vm._v("(admin only)"),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.admin
                                              ? _c(
                                                  "a",
                                                  {
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.auditPost.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Audit Post\n                                                "
                                                    ),
                                                    _vm.auditRequested
                                                      ? _c("span", [
                                                          _vm._v("Requested"),
                                                          _c("br"),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("em", [
                                                      _vm._v(
                                                        "(accredited user only)"
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "#" },
                                                on: {
                                                  click: _vm.togglePostMenu,
                                                },
                                              },
                                              [_vm._v("Cancel")]
                                            ),
                                          ],
                                          2
                                        ),
                                      ])
                                    : _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "menu__links" },
                                          [
                                            _c("ShareButtons", {
                                              attrs: {
                                                "community-name":
                                                  _vm.$root.community.name,
                                                title:
                                                  _vm.$root.post
                                                    .share_post_page_title,
                                                show: _vm.showShare,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("CopyLink", {
                                              attrs: {
                                                link:
                                                  "/" +
                                                  _vm.post.community_url +
                                                  "/" +
                                                  _vm.post.dyadey_id,
                                                "menu-name-event":
                                                  "bus-post-menu-toggle",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _vm.admin
                                              ? _c(
                                                  "a",
                                                  {
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.modalDeletePost(
                                                          _vm.post.post_id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Delete Post\n                                                "
                                                    ),
                                                    _c("em", [
                                                      _vm._v(
                                                        "(accredited user only)"
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "menu__source" },
                                          [
                                            _c("p", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: _vm.originalSourceUrl,
                                                    target:
                                                      _vm.post.repost_id > 0
                                                        ? "_self"
                                                        : "_blank",
                                                  },
                                                  on: {
                                                    click: _vm.togglePostMenu,
                                                  },
                                                },
                                                [_vm._v("View original source")]
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "menu__socials" },
                                              [
                                                _vm.post.network_id ===
                                                _vm.$simpleStore.Networks.FB
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "menu__social",
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: _vm.post
                                                                .uri,
                                                              target: "_blank",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.togglePostMenu,
                                                            },
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: _vm.$cdn(
                                                                  "/img2.0/icons/facebook.svg"
                                                                ),
                                                                alt: "facebook",
                                                                width: "25",
                                                                height: "25",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.post.network_id ===
                                                _vm.$simpleStore.Networks.IN
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "menu__social",
                                                      },
                                                      [
                                                        _vm.post.source
                                                          ? _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href: _vm.post
                                                                    .source,
                                                                  target:
                                                                    "_blank",
                                                                },
                                                                on: {
                                                                  click:
                                                                    _vm.togglePostMenu,
                                                                },
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: _vm.$cdn(
                                                                      "/img2.0/icons/instagram.svg"
                                                                    ),
                                                                    alt: "instagram",
                                                                    width: "25",
                                                                    height:
                                                                      "25",
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href: _vm.post
                                                                    .source,
                                                                  target:
                                                                    "_blank",
                                                                },
                                                                on: {
                                                                  click:
                                                                    _vm.togglePostMenu,
                                                                },
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: _vm.$cdn(
                                                                      "/img2.0/icons/instagram.svg"
                                                                    ),
                                                                    alt: "instagram",
                                                                    width: "25",
                                                                    height:
                                                                      "25",
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.post.network_id ===
                                                _vm.$simpleStore.Networks.YT
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "menu__social",
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: _vm.post
                                                                .uri,
                                                              target: "_blank",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.togglePostMenu,
                                                            },
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: _vm.$cdn(
                                                                  "/img2.0/icons/youtube.svg"
                                                                ),
                                                                alt: "facebook",
                                                                width: "25",
                                                                height: "25",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.post.network_id ===
                                                _vm.$simpleStore.Networks.TW
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "menu__social",
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: _vm.post
                                                                .uri,
                                                              target: "_blank",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.togglePostMenu,
                                                            },
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: _vm.$cdn(
                                                                  "/img2.0/icons/twitter.svg"
                                                                ),
                                                                alt: "facebook",
                                                                width: "25",
                                                                height: "25",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.post.children,
                                                  function (dupe) {
                                                    return [
                                                      dupe.network_id ===
                                                      _vm.$simpleStore.Networks
                                                        .FB
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "menu__social",
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: dupe.uri,
                                                                    target:
                                                                      "_blank",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.togglePostMenu,
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    attrs: {
                                                                      src: _vm.$cdn(
                                                                        "/img2.0/icons/facebook.svg"
                                                                      ),
                                                                      alt: "facebook",
                                                                      width:
                                                                        "25",
                                                                      height:
                                                                        "25",
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      dupe.network_id ===
                                                      _vm.$simpleStore.Networks
                                                        .IN
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "menu__social",
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: dupe.source,
                                                                    target:
                                                                      "_blank",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.togglePostMenu,
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    attrs: {
                                                                      src: _vm.$cdn(
                                                                        "/img2.0/icons/instagram.svg"
                                                                      ),
                                                                      alt: "instagram",
                                                                      width:
                                                                        "25",
                                                                      height:
                                                                        "25",
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      dupe.network_id ===
                                                      _vm.$simpleStore.Networks
                                                        .YT
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "menu__social",
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: dupe.uri,
                                                                    target:
                                                                      "_blank",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.togglePostMenu,
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    attrs: {
                                                                      src: _vm.$cdn(
                                                                        "/img2.0/icons/youtube.svg"
                                                                      ),
                                                                      alt: "facebook",
                                                                      width:
                                                                        "25",
                                                                      height:
                                                                        "25",
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      dupe.network_id ===
                                                      _vm.$simpleStore.Networks
                                                        .TW
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "menu__social",
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: dupe.uri,
                                                                    target:
                                                                      "_blank",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.togglePostMenu,
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    attrs: {
                                                                      src: _vm.$cdn(
                                                                        "/img2.0/icons/twitter.svg"
                                                                      ),
                                                                      alt: "facebook",
                                                                      width:
                                                                        "25",
                                                                      height:
                                                                        "25",
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                      ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "post__stats" },
                            [_c("like-repost-comment")],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "post__title" },
                              [
                                _c("h1", {
                                  domProps: {
                                    innerHTML: _vm._s(_vm.postTitle),
                                  },
                                }),
                                _vm._v(" "),
                                _vm.$root.brand.key === "klektive" &&
                                _vm.otlEnabled
                                  ? _c("own-the-look")
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("router-view"),
                  _vm._v(" "),
                  _vm.$root.user !== false
                    ? _c("a", {
                        staticClass: "c-article__add",
                        attrs: {
                          href: "/post/create/" + _vm.post.community_url,
                        },
                      })
                    : _c("a", {
                        staticClass: "c-article__add",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.showMemberPanel()
                          },
                        },
                      }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("modal"),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showDeleteModal
          ? _c("div", { staticClass: "menu delete-post" }, [
              _c("div", { staticClass: "o-grid o-grid--center u-bg-white" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "o-grid__item u-width-full u-a-center u-p-y6 u-p-x6",
                  },
                  [
                    _vm.showDeleteDraft === false
                      ? [
                          _c(
                            "h4",
                            {
                              staticClass:
                                "u-color-blue u-text-24 u-semibold u-m-b2",
                            },
                            [
                              _vm._v(
                                "\n                                Delete Post\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "u-m-b3" }, [
                            _vm._v(
                              "\n                                Are you sure you want to delete this post?\n                            "
                            ),
                          ]),
                        ]
                      : [
                          _c(
                            "h4",
                            {
                              staticClass:
                                "u-color-blue u-text-24 u-semibold u-m-b2",
                            },
                            [
                              _vm._v(
                                "\n                                Delete Draft\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "u-m-b3" }, [
                            _vm._v(
                              "\n                                Are you sure you want to delete this post?\n                            "
                            ),
                          ]),
                        ],
                    _vm._v(" "),
                    _c("div", { staticClass: "u-flex u-flex-justify-center" }, [
                      _vm.$root.user !== false &&
                      _vm.post.user_id === _vm.$root.user.id
                        ? _c(
                            "button",
                            {
                              staticClass: "c-btn c-btn--red u-m-r3",
                              on: {
                                click: function ($event) {
                                  return _vm.deletePost()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                                Yes delete my " +
                                  _vm._s(_vm.item) +
                                  "\n                            "
                              ),
                            ]
                          )
                        : _vm.admin === true
                        ? _c(
                            "button",
                            {
                              staticClass: "c-btn c-btn--red u-m-r3",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteCommunityPost()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                                Yes delete community post\n                            "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "c-btn c-btn--red is-outline",
                          on: { click: _vm.closeModal },
                        },
                        [
                          _vm._v(
                            "\n                                Cancel\n                            "
                          ),
                        ]
                      ),
                    ]),
                  ],
                  2
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.admin && _vm.showAuditPost
          ? _c("div", { staticClass: "menu audit-post" }, [
              _c("div", { staticClass: "o-grid o-grid--center u-bg-white" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "o-grid__item u-width-full u-a-center u-p-y6 u-p-x6",
                  },
                  [
                    _c(
                      "h4",
                      {
                        staticClass: "u-color-blue u-text-24 u-semibold u-m-b2",
                      },
                      [
                        _vm._v("\n                            Audit Post "),
                        _vm.auditRequested
                          ? _c("span", [_vm._v("Requested")])
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "u-m-b3" }, [
                      _vm._v(
                        "\n                            Classify post as appropriate below:\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "u-flex u-flex-justify-center" }, [
                      _c(
                        "button",
                        {
                          staticClass: "c-btn c-btn--red u-m-r3",
                          on: {
                            click: function ($event) {
                              return _vm.classifyPost("very good")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                                Very Good\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "c-btn c-btn--red u-m-r3",
                          on: {
                            click: function ($event) {
                              return _vm.classifyPost("average")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                                Average\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "c-btn c-btn--red u-m-r3",
                          on: {
                            click: function ($event) {
                              return _vm.classifyPost("bad")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                                Bad\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "c-btn c-btn--red u-m-r3",
                          on: {
                            click: function ($event) {
                              return _vm.classifyPost("inappropriate")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                                Inappropriate\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "c-btn c-btn--red is-outline",
                          on: { click: _vm.closeModal },
                        },
                        [
                          _vm._v(
                            "\n                                Cancel\n                            "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("related-content"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dots" }, [
      _c("div", { staticClass: "dot" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }